<template>
  <AppModalEdit
    v-model="isActive"
    :show-exec-button="false"
    :confirm-on-click-cancel="false"
    cancel-button-text="閉じる"
    title="メニュー詳細"
  >
    <v-container v-if="isActive" grid-list-md>
      <AppForm label="メニュー種類" single-span>
        <span :class="{ 'not-passed-record': !item.isRequestPassed }">
          {{ item.displayData.scopeString }}
        </span>
      </AppForm>
      <AppForm label="メニュー名称" single-span class="pt-1">
        <div class="pt-1" style="height:36px;">
          <div
            v-if="item.isRequestPassed"
            style="display:inline-block; min-width:100px; max-width:120px; width:20%"
          >
            <div v-if="!isDescriptionEditMode">
              <v-btn
                v-if="isNameEditMode"
                :loading="loading"
                class="inline-save-button"
                small
                color="primary"
                @click="saveNewName"
                >保存する</v-btn
              >
              <v-icon
                v-else
                class="inline-edit-button"
                @click="changeNameEditMode"
              >
                edit
              </v-icon>
            </div>
          </div>
          <div style="display:inline-block; width:80%;">
            <TextFieldInline
              v-show="isNameEditMode"
              ref="editNameArea"
              v-model="newName"
            />
            <span
              v-show="!isNameEditMode"
              :class="{ 'not-passed-record': !item.isRequestPassed }"
            >
              {{ item.displayData.name }}
            </span>
          </div>
        </div>
      </AppForm>
      <AppForm label="メニュー説明" single-span>
        <div class="pt-1">
          <div
            v-if="item.isRequestPassed"
            style="display:inline-block; min-width:100px; max-width:120px; width:20%"
          >
            <div v-if="!isNameEditMode">
              <v-btn
                v-if="isDescriptionEditMode"
                :loading="loading"
                class="inline-save-button"
                small
                color="primary"
                @click="saveNewDescription"
                >保存する</v-btn
              >
              <v-icon
                v-else
                class="inline-edit-button"
                @click="changeDescriptionEditMode"
              >
                edit
              </v-icon>
            </div>
          </div>
          <div style="display:inline-block; width:80%;">
            <v-textarea
              v-show="isDescriptionEditMode"
              ref="editDescriptionArea"
              v-model="newDescription"
              :rows="3"
            />
            <span
              v-show="!isDescriptionEditMode"
              :class="{ 'not-passed-record': !item.isRequestPassed }"
              style="white-space: pre-wrap"
              >{{ item.displayData.description }}</span
            >
          </div>
        </div>
      </AppForm>
      <AppForm class="pt-1" label="課金形態" single-span>
        <span
          class="pt-1"
          :class="{ 'not-passed-record': !item.isRequestPassed }"
        >
          {{ item.displayData.unitTypeString }}
        </span>
      </AppForm>
      <AppForm class="pt-1" label="配信単価" single-span>
        <AppCurrency
          :value="item.displayData.unitPrice"
          :class="{ 'not-passed-record': !item.isRequestPassed }"
        />
      </AppForm>
      <AppForm class="pt-1" label="使用可能期間" single-span>
        <span :class="{ 'not-passed-record': !item.isRequestPassed }">
          {{ item.displayData.dateRange }}
        </span>
      </AppForm>
      <AppForm class="pt-1" label="承認状態" single-span>
        <span :class="{ 'not-passed-record': !item.isRequestPassed }">
          {{ item.latestRequest.statusDisplayName }}
        </span>
      </AppForm>
      <RequestsTable
        :records="item.requests"
        :loading="loading"
        @cancelRequest="cancelRequest"
      />
    </v-container>
  </AppModalEdit>
</template>

<script>
import { actions, snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import TextFieldInline from '@/components/Shared/CrudUI/TextFieldInline'
import RequestsTable from './ModalDetailRequests'

export default {
  components: { TextFieldInline, RequestsTable },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      newDescription: '',
      newName: '',
      isDescriptionEditMode: false,
      isNameEditMode: false,
      loading: false,
    }
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    changeDateRange(obj) {
      this.useDateRange = obj.useDateRange
      this.startDate = obj.startDate
      this.endDate = obj.endDate
    },
    changeDescriptionEditMode() {
      this.newDescription = this.item.description
      this.isDescriptionEditMode = true
      this.$nextTick(() => this.$refs.editDescriptionArea.focus())
    },
    async saveNewDescription() {
      this.loading = true
      try {
        await this.item.edit({
          name: this.item.name,
          description: this.newDescription,
          status: this.item.status,
        })
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '保存に成功しました',
        })
      } catch (e) {
        this.loading = false
        const error = new Error('保存に失敗しました。')
        throw error
      }
      this.loading = false
      this.isDescriptionEditMode = false
    },
    changeNameEditMode() {
      this.newName = this.item.name
      this.isNameEditMode = true
      this.$nextTick(() => this.$refs.editNameArea.focus())
    },
    async saveNewName() {
      this.loading = true
      try {
        await this.item.edit({
          name: this.newName,
          description: this.item.description,
          status: this.item.status,
        })
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '保存に成功しました',
        })
      } catch (e) {
        this.loading = false
        const error = new Error('保存に失敗しました。')
        throw error
      }
      this.loading = false
      this.isNameEditMode = false
    },
    async cancelRequest(target) {
      const result = await this.$confirm(undefined, {
        body: 'この申請を取り消しますがよろしいですか？',
      })
      if (!result) return
      try {
        await target.cancelRequest()
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '取り消し申請に成功しました',
        })
      } catch (e) {
        this.loading = false
        const error = new Error('取り消し申請に失敗しました。')
        throw error
      }
      this.loading = false
    },
  },
}
</script>

<style scoped>
.v-textarea {
  padding: 0;
}
.v-textarea >>> textarea {
  font-weight: 500;
  font-size: 14px;
}
.inline-edit-button {
  font-size: 18px;
  padding-left: 32px;
}
.inline-save-button {
  height: 18px;
  padding: 0;
}
.not-passed-record {
  opacity: 0.25;
}
</style>
